import { Fragment } from "react";
import "./WebApplication.css";
import analysis from "../../assets/images/services/webapp/analysis.png";
import planning from "../../assets/images/services/webapp/planning.png";
import uiandux from "../../assets/images/services/webapp/uiandux.png";
import development from "../../assets/images/services/webapp/development.png";
import testingandquality from "../../assets/images/services/webapp/testingandquality.png";
import deployment from "../../assets/images/services/webapp/deployment.png";
import scalablewebapp from "../../assets/images/services/webapp/scalablewebapp.png";
import securearchitecture from "../../assets/images/services/webapp/securearchitecture.png";
import highperformance from "../../assets/images/services/webapp/highperformance.png";

const WebApplication = () => {
  return (
    <Fragment>
      <section className="webapplication-style">
        <div className="app-banner">
          <div className="banner-overlay"></div>
          <div
            className="banner-content"
            data-aos="fade-down"
            data-aos-offset="300"
          >
            <h1 className="fw-bold">Web Application Development Company</h1>
            <p>
              We are the leading website development company offering end-to-end
              web development services. We handcraft refined solutions with the
              synergistic effort of our experienced and dedicated team of web
              developers to transform your dreams into a unique reality.
            </p>
          </div>
        </div>
        <div
          className="custom-webapp"
          data-aos="fade-down"
          data-aos-offset="300"
        >
          <h4 className="mb-4">
            Compelling Custom Web development solutions to reshape your business
          </h4>
          <p className="mb-4">
            Our dedicated Nextbrain team offers integrated tailor-made website
            development services for your dream website. We extend our seamless
            services in building unique, robust, responsive, user-friendly, and
            scalable websites that improve your business growth through improved
            traffic. With the help of advanced technologies, agile
            methodologies, online marketing methods along skilled manpower, we
            resolve any inconsistencies into feasible solutions.
          </p>
          <p>
            Being the best website development company in india, we follow a
            customer-centric approach meeting all the requirements and
            objectives of the customers. Our services have extended to
            start-ups, small, and medium-sized industries across different
            verticals. We provide large scale web app services consisting of
            simple content website applications, e-business applications, and
            complex internet applications.
          </p>
        </div>
        <div
          className="webapp-process"
          data-aos="fade-down"
          data-aos-delay="200"
          data-aos-duration="1200"
        >
          <h4 className="mb-4">Web application development process</h4>
          <p>
            We focus on developing quality websites that are enticing, highly
            responsive, easy-to-navigate, robust, and secure. We follow
            well-planned strategies and agile methodologies along with a
            systematic stepwise development process. We give importance to small
            details with an insight to handcraft the best websites that can
            drive more traffic.
          </p>
        </div>
        <div className="webapp-process-content position-relative">
          <div className="container">
            <div className="text-center mb-5">
              <h2
                className="fw-bold"
                data-aos="fade-down"
                data-aos-easing="linear"
                data-aos-duration="1500"
              >
                Our Web Application Development Process
              </h2>
            </div>

            {/* Step 1 */}
            <div className="row align-items-center mb-5">
              <div
                className="col-lg-6 col-md-6"
                data-aos="fade-right"
                data-aos-easing="ease-in-sine"
              >
                <h5 className="step-number">01</h5>
                <h3 className="fw-bold">Discovery & Requirement Analysis</h3>
                <p>
                  We understand your business goals, target audience, and
                  functional requirements to create a strong foundation.
                </p>
              </div>
              <div
                className="col-lg-6 col-md-6 text-center"
                data-aos="fade-left"
                data-aos-easing="ease-in-sine"
              >
                <img src={analysis} className="process-icon" alt="Discovery" />
              </div>
            </div>

            {/* Step 2 */}
            <div className="row align-items-center mb-5 flex-md-row-reverse">
              <div
                className="col-lg-6 col-md-6"
                data-aos="fade-right"
                data-aos-easing="ease-in-sine"
              >
                <h5 className="step-number">02</h5>
                <h3 className="fw-bold">Planning & Architecture</h3>
                <p>
                  We define the technology stack, application architecture, and
                  development roadmap for scalability.
                </p>
              </div>
              <div
                className="col-lg-6 col-md-6 text-center"
                data-aos="fade-left"
                data-aos-easing="ease-in-sine"
              >
                <img src={planning} className="process-icon" alt="Planning" />
              </div>
            </div>

            {/* Step 3 */}
            <div className="row align-items-center mb-5">
              <div
                className="col-lg-6 col-md-6"
                data-aos="fade-right"
                data-aos-easing="ease-in-sine"
              >
                <h5 className="step-number">03</h5>
                <h3 className="fw-bold">UI / UX Design</h3>
                <p>
                  We design intuitive interfaces and smooth user experiences
                  that improve engagement and usability.
                </p>
              </div>
              <div
                className="col-lg-6 col-md-6 text-center"
                data-aos="fade-left"
                data-aos-easing="ease-in-sine"
              >
                <img src={uiandux} className="process-icon" alt="Design" />
              </div>
            </div>

            {/* Step 4 */}
            <div className="row align-items-center mb-5 flex-md-row-reverse">
              <div
                className="col-lg-6 col-md-6"
                data-aos="fade-right"
                data-aos-easing="ease-in-sine"
              >
                <h5 className="step-number">04</h5>
                <h3 className="fw-bold">Development</h3>
                <p>
                  Our developers build frontend and backend features using
                  modern frameworks and best practices.
                </p>
              </div>
              <div
                className="col-lg-6 col-md-6 text-center"
                data-aos="fade-left"
                data-aos-easing="ease-in-sine"
              >
                <img
                  src={development}
                  className="process-icon"
                  alt="Development"
                />
              </div>
            </div>

            {/* Step 5 */}
            <div className="row align-items-center mb-5">
              <div
                className="col-lg-6 col-md-6"
                data-aos="fade-right"
                data-aos-easing="ease-in-sine"
              >
                <h5 className="step-number">05</h5>
                <h3 className="fw-bold">Testing & Quality Assurance</h3>
                <p>
                  We perform rigorous testing to ensure performance, security,
                  and bug-free delivery.
                </p>
              </div>
              <div
                className="col-lg-6 col-md-6 text-center"
                data-aos="fade-left"
                data-aos-easing="ease-in-sine"
              >
                <img
                  src={testingandquality}
                  className="process-icon"
                  alt="Testing"
                />
              </div>
            </div>

            {/* Step 6 */}
            <div className="row align-items-center flex-md-row-reverse">
              <div
                className="col-lg-6 col-md-6"
                data-aos="fade-right"
                data-aos-easing="ease-in-sine"
              >
                <h5 className="step-number">06</h5>
                <h3 className="fw-bold">Deployment & Maintenance</h3>
                <p>
                  We deploy the application, monitor performance, and provide
                  continuous support and updates.
                </p>
              </div>
              <div
                className="col-lg-6 col-md-6 text-center"
                data-aos="fade-left"
                data-aos-easing="ease-in-sine"
              >
                <img
                  src={deployment}
                  className="process-icon"
                  alt="Deployment"
                />
              </div>
            </div>
          </div>
        </div>

        <div className="why-choose-us">
          <div className="container ">
            <div className="row">
              <div className="col-lg-6 col-md-12">
                <div className="leftside-content" data-aos="fade-right">
                  <h4>Why are we the best Web app development company?</h4>
                  <p>
                    We work with a perspective to deliver the best websites
                    through the integration of the right tools, technologies,
                    resources, and world-class expertise. Being the top website
                    design company in India, we extend our remarkable services
                    to many business enterprises.
                  </p>
                </div>
              </div>
              <div className="col-lg-6 col-md-12">
                <div className="rightside-card" data-aos="zoom-in-up">
                  <div
                    data-text="Scalable Web App"
                    style={{ "--r": "-15" }}
                    className="glass"
                  >
                    <img
                      src={scalablewebapp}
                      alt="img-not-found"
                      className="icon1"
                    />
                  </div>

                  <div
                    data-text="Secure Architecture"
                    style={{ "--r": "5" }}
                    className="glass"
                  >
                    <img
                      src={securearchitecture}
                      alt="img-not-found"
                      className="icon2"
                    />
                  </div>

                  <div
                    data-text="High Performance"
                    style={{ "--r": "25" }}
                    className="glass"
                  >
                    <img
                      src={highperformance}
                      alt="img-not-found"
                      className="icon3"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </Fragment>
  );
};
export default WebApplication;
